import OrderCard from '@/components/ui/order-card/order-card';
export default OrderCard;
